

import { 
  getPersonNameOptions, getPersonName, PersonNameContext,
  PersonName,
} from 'lib-core'


export { getPersonNameOptions, getPersonName, PersonNameContext }

export default PersonName
